import type { TextProps } from "@octopusdeploy/design-system-components";
import { DebounceValue, TextWithLabel as Text } from "@octopusdeploy/design-system-octopus-components";
import type * as React from "react";
interface AdvancedFilterTextInputProps {
    fieldName: string;
    value: string;
    onChange(value: string): void;
    disabled?: boolean;
}
const DebouncedText = DebounceValue<TextProps & {
    fieldName?: string;
}, string>(Text);
export const AdvancedFilterTextInput: React.FC<AdvancedFilterTextInputProps> = (props: AdvancedFilterTextInputProps) => {
    return <DebouncedText disabled={props.disabled} fieldName={props.fieldName} onChange={props.onChange} value={props.value}/>;
};
AdvancedFilterTextInput.displayName = "AdvancedFilterTextInput"
